import React, { useCallback, useState } from 'react';
import { Card, CardBody, CardSubhead, CardTitle } from '@spark/ui-components/components/Card';
import { notification } from '@spark/ui-components/utils/notification';
import CobrancasDepositoFilter from './CobrancasDepositoFilter';
import CobrancasDepositoTable from './CobrancasDepositoTable';
import { useDepositoCobrancasListagem } from '../hooks/useDepositoCobrancasListagem';
import {
  cancelarCobrancaDepositoPorTipo,
  getApiErrorMessage,
  mapTipoCobranca
} from '../utils/cobrancasDepositoUtils';

const CobrancasDepositoCard = () => {
  const [cancelandoCobranca, setCancelandoCobranca] = useState(null);
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    filtros,
    paginationState,
    refreshData,
    handleFilterApply,
    handleLimparFiltros,
    setPaginationState
  } = useDepositoCobrancasListagem();

  const handleCancelarCobranca = useCallback(
    async (row) => {
      const protocolo = row?.protocoloPedidoTMS;
      const tipoCobranca = mapTipoCobranca(row?.tipoCobranca);

      if (!tipoCobranca || !protocolo) return;
      if (!window.confirm('Confirma o cancelamento desta cobranca?')) return;

      try {
        setCancelandoCobranca({ tipoCobranca, protocolo });
        await cancelarCobrancaDepositoPorTipo(tipoCobranca, protocolo);
        notification.success('Cobranca cancelada com sucesso!');
        await refreshData();
      } catch (error) {
        notification.error(getApiErrorMessage(error, 'Erro ao cancelar cobranca'));
        console.error('Erro ao cancelar cobranca:', error);
      } finally {
        setCancelandoCobranca(null);
      }
    },
    [refreshData]
  );

  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-0">Cobranças Depósito</CardTitle>
        <CardSubhead>Total de registros: {totalRegistros}</CardSubhead>

        <CobrancasDepositoFilter
          loading={filterLoading}
          onApply={handleFilterApply}
          onLimpar={() => handleLimparFiltros(filtros)}
        />

        <CobrancasDepositoTable
          data={data}
          loading={loading}
          totalRegistros={totalRegistros}
          paginationState={paginationState}
          setPaginationState={setPaginationState}
          onCancelarCobranca={handleCancelarCobranca}
          cancelandoCobranca={cancelandoCobranca}
        />
      </CardBody>
    </Card>
  );
};

export default CobrancasDepositoCard;
